import { Typography } from "@mui/material";
import { useFormikContext } from "formik";
import { ReactElement } from "react";

import {
  FormikDurationField,
  FormikSwitchField,
  FormikTextField,
} from "~frontend/components/forms";
import { useSubaccountAdminConfig } from "~frontend/providers/SubaccountProvider";

import { AddOrEditInboxFormValues } from "./types";

export function InboxTexterSettings(): ReactElement {
  const subaccount = useSubaccountAdminConfig()!;

  const { values } = useFormikContext<AddOrEditInboxFormValues>();

  const defaultAssignmentBatchSizeText =
    subaccount.texterAssignmentBatchSize.toLocaleString();
  const defaultAssignmentDurationText =
    subaccount.texterAssignmentExpirationMinutes < 60
      ? `${subaccount.texterAssignmentExpirationMinutes} minutes`
      : subaccount.texterAssignmentExpirationMinutes === 60
        ? `${subaccount.texterAssignmentExpirationMinutes / 60} hour`
        : `${subaccount.texterAssignmentExpirationMinutes / 60} hours`;

  return (
    <>
      {!values.texterAssignmentBatchSizeOverrideSubaccount &&
        !values.texterAssignmentExpirationMinutesOverrideSubaccount && (
          <Typography variant="body1">
            This inbox will use your team's default assignment batch size{" "}
            <strong>({defaultAssignmentBatchSizeText})</strong> and your team’s
            default assignment duration{" "}
            <strong>({defaultAssignmentDurationText})</strong>
          </Typography>
        )}
      {!values.texterAssignmentBatchSizeOverrideSubaccount &&
        values.texterAssignmentExpirationMinutesOverrideSubaccount && (
          <Typography variant="body1">
            This inbox will use your team's default assignment batch size{" "}
            <strong>({defaultAssignmentBatchSizeText})</strong>
          </Typography>
        )}{" "}
      {values.texterAssignmentBatchSizeOverrideSubaccount &&
        !values.texterAssignmentExpirationMinutesOverrideSubaccount && (
          <Typography variant="body1">
            This inbox will use your team's default assignment duration{" "}
            <strong>({defaultAssignmentDurationText})</strong>
          </Typography>
        )}
      <FormikSwitchField
        name="texterAssignmentBatchSizeOverrideSubaccount"
        label="Override default batch size"
      />
      {values.texterAssignmentBatchSizeOverrideSubaccount && (
        <FormikTextField
          fullWidth
          name="texterAssignmentBatchSize"
          label="Texter Assignment Batch Size"
          type="number"
          bottomLabel="The number of replies that will be assigned to a texter at a time"
        />
      )}
      <FormikSwitchField
        name="texterAssignmentExpirationMinutesOverrideSubaccount"
        label="Override default assignment duration"
      />
      {values.texterAssignmentExpirationMinutesOverrideSubaccount && (
        <FormikDurationField
          name="texterAssignmentExpirationMinutes"
          label="Assignment Duration"
          bottomLabel="After this amount of time, assignments will go back into the pool for reassignment"
          fullWidth
        />
      )}
    </>
  );
}
